import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { InputField } from '.';

const NumberInputField = ({
  name,
  value,
  onChange,
  onBlur,
  disabled = false,
  autoFocus = false,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (isEditing) {
      inputRef.current.select();
    }
  }, [isEditing]);

  const handleBlur = e => {
    setIsEditing(false);
    if (onBlur) onBlur(e);
  };

  const handleFocus = () => setIsEditing(true);

  const formatValue = () => {
    return value;
  };

  return isEditing ? (
    <InputField
      ref={inputRef}
      type='number'
      name={name}
      autoComplete='off'
      value={formatValue()}
      onChange={onChange}
      onBlur={handleBlur}
      autoFocus={autoFocus}
      disabled={disabled}
    />
  ) : (
    <InputField
      ref={inputRef}
      name={name}
      autoComplete='off'
      value={Number(value).toLocaleString('sv-SE')}
      onChange={onChange}
      onFocus={handleFocus}
      autoFocus={autoFocus}
      disabled={disabled}
      readonly
    />
  );
};

NumberInputField.propTypes = {
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default NumberInputField;
